import { LibraryTypes } from '~/types/adamTypes';

export type UseLibraryPageOrForm = {
  libraryStrategy: UseLibraryStrategy;
  libraryManager: UseLibrary;
  libraryViewRouter: UseLibraryViewRouter;
};

export const INJECT_LIBRARY_PAGE_OR_FORM = Symbol(
  'useLibraryPageOrForm composable'
) as InjectionKey<UseLibraryPageOrForm>;

export const useLibraryPageOrForm = (
  strategy: 'page' | 'form' = 'page',
  libraryType: LibraryTypes.RootBox | LibraryTypes.FreeLibraryRootBox
): UseLibraryPageOrForm => {
  const libraryManager = useLibrary(libraryType);

  const libraryStrategy = useLibraryStrategy(strategy);

  const { library, libraryBook } = libraryManager;

  const libraryViewRouter = useLibraryViewRouter(library, libraryBook);

  watch(
    () => toValue(libraryStrategy.slugs),
    async (slugs) => {
      await libraryManager.load(slugs, 2);
    }
  );

  return {
    libraryStrategy,
    libraryManager,
    libraryViewRouter,
  };
};
